import React, { Component, Fragment } from 'react';
// import { withRouter } from 'react-router'
// import { connect } from 'react-redux'
import SliderList from '../../containers/SliderList'
import SportItem from './SportItem'
class Sport extends Component {
  constructor(props){
    super(props);
    this.state= {
        type : 4
    }
   ;
  }
  render() {
    return (
       <Fragment>
           <SliderList type ={this.state.type} />
        <div>
        <div className="block-index-sport-another">
          <div className="container">
              <SportItem type = {this.state.type} />
          </div>
        </div>
        </div>
        </Fragment>
    );
  }
}
export default Sport;




// WEBPACK FOOTER //
// ./src/components/Sports/Sport.js